import { createSignal } from "solid-js";
import type { KeyboardScope } from "../enums/shell";
import { KEYBOARD_SCOPE } from "../enums/shell";
import { bindingsFor } from "./registry";

const [scope, writeScope] = createSignal<KeyboardScope>(KEYBOARD_SCOPE.LIST);

export function setScope(next: KeyboardScope): void {
  writeScope(next);
}

export function startKeyboard(): void {
  window.addEventListener("keydown", (event) => {
    const combo = normalize(event);
    const typing = isTextEntry(event.target);
    // While typing, only escape and mod+k are allowed to fire.
    if (typing && combo !== "escape" && combo !== "mod+k") {
      return;
    }
    const match = bindingsFor(scope()).find(
      (binding) => binding.combo === combo,
    );
    if (match) {
      event.preventDefault();
      match.run();
    }
  });
}

function normalize(event: KeyboardEvent): string {
  const parts: string[] = [];
  if (event.metaKey || event.ctrlKey) {
    parts.push("mod");
  }
  if (event.shiftKey && event.key.length > 1) {
    parts.push("shift");
  }
  const key = event.key.toLowerCase();
  const named =
    key === " "
      ? "space"
      : key === "escape"
        ? "escape"
        : event.key === "?"
          ? "?"
          : key;
  parts.push(named);
  return parts.join("+");
}

function isTextEntry(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement
  );
}
